import { render, staticRenderFns } from "./SectionNewRegistration.vue?vue&type=template&id=5158d30a&"
import script from "./SectionNewRegistration.vue?vue&type=script&lang=js&"
export * from "./SectionNewRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports